import { THEME } from '@lyon/utils/theme';
import { ButtonOverrides } from 'baseui/button';

export const BUTTON: ButtonOverrides = {
  BaseButton: {
    style: {
      width: '152px',
      marginTop: '40px',
      [THEME.media.medium]: {
        marginTop: '8px',
        marginLeft: 0,
      },
    },
  },
};
